module.exports = __webpack_public_path__ + "static/media/icon_76.f604d7ba.svg";